var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMask,
          expression: "showMask",
        },
      ],
      ref: "focus",
      staticClass: "base-loading",
      attrs: {
        "aria-live": "assertive",
        "aria-atomic": "true",
        tabindex: "-1",
        "aria-label": _vm.label,
      },
    },
    [
      _c("img", {
        staticClass: "spinner",
        attrs: { src: require("@/assets/loading.svg"), alt: "", width: "60px" },
      }),
      _c("div", { staticClass: "base-loading-text" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }